import useDictionary from 'lib/sitecore/use-dictionary';
import { useSession } from 'next-auth/react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const UserAuthenticated = (): JSX.Element => {
  const { data: session } = useSession();
  const fullName = session?.user?.name || '';
  const firstName = fullName.substring(0, fullName.indexOf(' '));
  const dictionary = useDictionary();
  const emailDisclaimerText = dictionary.Forms_Email_Disclaimer_Text;
  const welcomeText = dictionary.Forms_WelcomeText;
  return (
    <div>
      {welcomeText} {firstName}. {emailDisclaimerText}
    </div>
  );
};

const FormUserName = (): JSX.Element => {
  const skipAuthentication = process.env.SKIP_AUTHENTICATION === 'true' ? true : false;
  const pageState = useSitecoreContext().sitecoreContext.pageState;

  if (pageState === 'normal') {
    if (skipAuthentication) {
      return <></>;
    }
    return <UserAuthenticated />;
  }
  return <></>;
};

export default FormUserName;
